module.exports = __webpack_public_path__ + "staticcomp/img/top.5b58ca2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/11/top.jpg
// module id = SYNW
// module chunks = 39